const dataExport = {
  export: 'Exportieren',
  errorMessage: 'Beim Datenexport sind unerwartete Fehler aufgetreten.',
  waitForDownloadMessage: 'your download will start shortly.,Anfrage gesendet, Ihr Download beginnt in Kürze., your download will start shortly.',
  exportToCsv: {
    title: 'CSV exportieren',
    body: 'Sie sind dabei, eine CSV-Datei für {{selectedCount}} {{itemsLabel}} zu exportieren.',
  },
};

export default dataExport;
